function t(){const t=this,e=t.slides;for(let f=0;f<e.length;f+=1)e[f].swiperSlideOffset=t.isHorizontal()?e[f].offsetLeft:e[f].offsetTop}export{t as default};
//# sourceMappingURL=updateSlidesOffset.js.map
